// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Trascina qui i file: PDF, foto, Excel, CSV o Word',
  waiting: "L'invio attende il caricamento dei file.",
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} pagina',
  pages_other: '{{count}} pagine',
  problems: {
    type: 'Questo tipo di file non può essere inviato. Invia un PDF, una foto (JPG, PNG o HEIC) oppure un file Excel, CSV o Word.',
    size: 'Supera i 20 MB. Un file può pesare al massimo 20 MB.',
    empty: 'Questo file è vuoto.',
    count: 'Massimo 10 file per messaggio.',
    upload: 'Il caricamento si è interrotto. Riprova.',
  },
};
